import React from 'react';
import makeStyles from "@material-ui/core/styles/makeStyles";
import {Grid} from "@material-ui/core";
import InputField from "../../../FormikUtils/InputField";
import SelectField from "../../../FormikUtils/SelectField";
import {Field} from "formik";
import FormikAutocomplete from "../../../FormikUtils/FormikAutocomplete";


const useStyle = makeStyles((theme) => ({
    titulo: {
        fontSize: '24px',
        color: '#35303f',
        fontFamily: 'Ubuntu',
        fontWeight: 'bold',
        letterSpacing: '-0.75'

    },
    subtitulo: {
        fontSize: '14px',
        color: '#8a8597',
        fontFamily: 'Nunito',
        textAlign: ' justify',

    }
}))


const sexos = [
    {value: 'hombre', label: 'Hombre'},
    {value: 'mujer', label: 'Mujer'},
    {value: 'otro', label: 'Otro'},
    {value: 'no_contesta', label: 'Prefiero no contestar'}
];

function PersonalForm(props) {
    const classes = useStyle();
    const {localidades} = props;

    const {
        formField: {
            names,
            lastName,
            codArea,
            phone,
            email,
            dni,
            cuit,
            address,
            sex,
            postCode,
            codigosLocalidad
        }
    } = props;


    return (
        <React.Fragment>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                    <InputField name={names.name} label={names.label} fullWidth
                                textTransform={'capitalize'}/>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <InputField name={lastName.name} label={lastName.label} fullWidth
                                textTransform={'capitalize'}/>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <InputField name={dni.name} label={dni.label} fullWidth  textTransform={'uppercase'}/>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <InputField name={cuit.name} label={cuit.label} fullWidth  textTransform={'uppercase'}/>
                </Grid>

                <Grid item xs={12} md={6}>
                    <SelectField
                        name={sex.name}
                        label={sex.label}
                        data={sexos}
                        fullWidth
                    />
                </Grid>

                <Grid item xs={12}>
                    <InputField
                        name={email.name}
                        label={email.label}
                        fullWidth
                        textTransform={'lowercase'}
                    />
                </Grid>
                <Grid item xs={4}>
                    <InputField
                        name={codArea.name}
                        label={codArea.label}
                        placeholder="Ej: 351"
                        fullWidth
                        textTransform={'uppercase'}
                    />
                </Grid>
                <Grid item xs={8}>
                    <InputField
                        name={phone.name}
                        label={phone.label}
                        placeholder="Sin el 15"
                        fullWidth
                        textTransform={'uppercase'}
                    />
                </Grid>

                <Grid item xs={12}>
                    <InputField name={address.name} label={address.label} fullWidth
                                textTransform={'capitalize'}/>
                </Grid>
                <Grid item xs={12}>
                    <Field
                        name={codigosLocalidad.name}
                        label={codigosLocalidad.label}
                        component={FormikAutocomplete}
                        options={localidades}
                        textFieldProps={{
                            label: codigosLocalidad.label,
                            required: true,
                        }}
                    />
                </Grid>

            </Grid>
        </React.Fragment>
    );
}

export default PersonalForm;